import React from "react"

// redux
import { useSelector } from "react-redux"

// styles
import Styles from "./footer.module.css"
import { FormattedMessage, injectIntl } from "react-intl"

// components
import FooterLink from "./FooterLink"

// icons
// import WenLogo from "../../assets/icons/wen-logos/wen-header-dark.svg"
// import WenLogoLight from "../../assets/icons/wen-logos/wen-header-light.svg"
import {
  FaInstagram,
  FaLinkedin,
  FaTwitter
} from "react-icons/fa"
// --- payments icons

function Footer() {
  const theme = useSelector((state) => state.theme.value)
  const exchangeName = useSelector((state) => state.exchangeCustomization.value.name)
  const assets = useSelector(state => state.exchangeAssets.value)

  const sections = [
    {
      //   title: <FormattedMessage id="page.footer.exchange" />,
      title: "The Platform",
      links: [
        { text: "Markets", url: "/markets" },
        { text: <FormattedMessage id="page.footer.exchange" />, url: "/trade" },
        {
          text: <FormattedMessage id="page.footer.convert" />,
          url: "/convert"
        },
        // {
        //   text: <FormattedMessage id="page.footer.launchpad" />,
        //   url: "/launchpad"
        // },
        {
          text: <FormattedMessage id="page.footer.wallet" />,
          url: "/account/wallet/overview"
        }
      ]
    },
    {
      title: <FormattedMessage id="page.footer.support" />,
      links: [
        // {
        //   text: <FormattedMessage id="page.footer.requestForm" />,
        //   url: "/request_form"
        // },
        // {
        //   text: <FormattedMessage id="page.footer.contactSupport" />,
        //   url: "/contact_support"
        // },
        // { text: <FormattedMessage id="page.footer.faq" />, url: "/FAQ" },
        // {
        //   text: <FormattedMessage id="page.footer.security" />,
        //   url: "/security"
        // }
        {
          text: "Your Tech Matters",
          url: "/your-bit-matters"
        },
        {
          text: "Contact Support",
          url: "/contact-support"
        },
        {
          text: "FAQs",
          url: "/faq"
        }
      ]
    },
    {
      title: <FormattedMessage id="page.footer.resources" />,
      links: [
        {
          text: <FormattedMessage id="page.footer.downloads" />,
          url: "/downloads"
        },
        {
          text: <FormattedMessage id="page.footer.mobileApplication" />,
          url: "/mobile-application"
        },
        // {
        //   text: <FormattedMessage id="page.footer.buyCrypto" />,
        //   url: "/buy_crypto"
        // },
        // {
        //   text: <FormattedMessage id="page.footer.referral" />,
        //   url: "/referral"
        // },
        // {
        //   text: <FormattedMessage id="page.footer.listingTranding" />,
        //   url: "/listing_tranding"
        // }
        {
          text: "Bring Your Crew",
          url: "/crew"
        },
        {
          text: "Fees",
          url: "/fees"
        }
      ]
    },
    {
      title: <FormattedMessage id="page.footer.learn" />,
      links: [
        {
          text: <FormattedMessage id="page.footer.whatsTrending" />,
          url: "/blogs/trending"
        },
        // {
        //   text: <FormattedMessage id="page.footer.productNews" />,
        //   url: "/product_news"
        // },
        {
          text: "Wen’s new techs",
          // url: "/news"
          url: "/blogs/wen-new-bits"
        },
        {
          text: <FormattedMessage id="page.footer.events" />,
          url: "/blogs/events"
        },
        // {
        //   text: <FormattedMessage id="page.footer.university" />,
        //   url: "/university"
        // },
        // {
        //   text: <FormattedMessage id="page.footer.research" />,
        //   url: "/research"
        // },
        // {
        //   text: <FormattedMessage id="page.footer.marketUpdate" />,
        //   url: "/market_update"
        // }
        {
          text: "Inside Scoop",
          url: "/blogs/inside-scoop"
        },
        {
          text: "The latest buzz",
          // url: "/market_update"
          url: "/blogs/latest-buzz"
        }
      ]
    },
    {
      title: <FormattedMessage id="page.footer.company" />,
      links: [
        {
          text: <FormattedMessage id="page.footer.aboutUs" />,
          url: "/about-us"
        },
        {
          text: <FormattedMessage id="page.footer.careers" />,
          url: "/careers"
        },
        {
          text: "Supported companies",
          url: "/support-companies"
        },
        // { text: <FormattedMessage id="page.footer.news" />, url: "/news" },
        {
          text: <FormattedMessage id="page.footer.security" />,
          url: "/company-security"
        }
        // {
        //   text: <FormattedMessage id="page.footer.community" />,
        //   url: "/community"
        // },
        // {
        //   text: <FormattedMessage id="page.footer.announcements" />,
        //   url: "/announcements"
        // }
      ]
    }
  ]

  return (

    <footer
      className={Styles.mainContainer}
    >

      <div className={Styles.bottomContainer}>


        {/* <div className={Styles.mobilePaymentContainer}>
          <span>We accept following payment systems</span>

          <div className={Styles.footerPaymentsIonsContainer}>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? <VisaIcon /> : <VisaIconLight />}
            </div>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? <MastercardIcon /> : <MastercardIconLight />}
            </div>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? <BitcoinIcon /> : <BitcoinIconLight />}
            </div>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? (
                <CreditsCardsIcon
                  style={{ transform: "translateY(3px) translateX(2px)" }}
                />
              ) : (
                <CreditsCardsIconLight
                  style={{ transform: "translateY(3px) translateX(2px)" }}
                />
              )}
            </div>
          </div>
        </div> */}

        {/* left container */}
        <div className={Styles.bottomLeftContainer}>
          © 2023 WealthTech. <FormattedMessage id="page.footer.allRightsReserved" />
        </div>

        {/* mid container */}
        <div className={Styles.bottomMidContainer}>
          <FooterLink
            to="/terms-and-conditions"
            text="Terms & conditions"
            key={"terms-conditions"}
          />
          <FooterLink
            text="Privacy Policy"
            key={"privacy-policy"}
            to="/privacy-and-policy"
          />
          <FooterLink
            text={<FormattedMessage id="page.footer.accountDeletionPolicy" />}
            key={"account-deletion-policy"}
            to="/account-deletion-policy"
          />
        </div>

        {/* right container */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          {/* <span style={{ color: "var(--gray-color)" }}>
            We accept following payment systems
          </span>
          <div className={Styles.bottomRightContainer}>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? <VisaIcon /> : <VisaIconLight />}
            </div>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? <MastercardIcon /> : <MastercardIconLight />}
            </div>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? <BitcoinIcon /> : <BitcoinIconLight />}
            </div>
            <div className={Styles.paymentCard}>
              {theme === "dark" ? (
                <CreditsCardsIcon
                  style={{ transform: "translateY(3px) translateX(2px)" }}
                />
              ) : (
                <CreditsCardsIconLight
                  style={{ transform: "translateY(3px) translateX(2px)" }}
                />
              )}
            </div>
          </div> */}
        </div>
        <div className={Styles.mediaLinksContainerMobile}>
          <FooterLink
            //to='www.instagram.com'
            key="www.instagram.com"
            text={<FaInstagram size={18} />}
            animationDirection="up"
          />
          <FooterLink
            //to='www.twitter.com'
            key="www.twitter.com"
            text={<FaTwitter size={18} />}
            animationDirection="up"
          />
          <FooterLink
            //to='www.linkedin.com'
            key="www.linkedin.com"
            text={<FaLinkedin size={18} />}
            animationDirection="up"
          />
        </div>
      </div>
    </footer>
  )
}

export default injectIntl(Footer)
